import { render } from "./B2bTableDeliveryNotesReceived.vue?vue&type=template&id=0d5efa4f&scoped=true&lang=pug"
import script from "./B2bTableDeliveryNotesReceived.vue?vue&type=script&lang=js"
export * from "./B2bTableDeliveryNotesReceived.vue?vue&type=script&lang=js"

import "./B2bTableDeliveryNotesReceived.vue?vue&type=style&index=0&id=0d5efa4f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d5efa4f"]])

export default __exports__